import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { IChatMessage, IChatThread, ChatThread } from 'app/@chat/domain';
import { ChatMessageService } from 'app/@chat/services/chat-message.service';
import { ChatThreadService } from 'app/@chat/services/chat-thread.service';
import { interval, Observable, combineLatest, Subscription } from 'rxjs';
import { debounce, map, tap, debounceTime, distinct } from 'rxjs/operators';
import * as moment from 'moment';
import { Utility } from 'app/@core/utils/utility';
import { ChatService } from 'app/@chat/chat.service';
import { getThreadStatusText, isThreadOnline } from 'app/@chat/utils/utils';

@Component({
  selector: 'app-threads',
  templateUrl: './threads.component.html',
  styleUrls: ['./threads.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadsComponent implements OnInit {
  threads: Observable<ChatThread[]>;

  @Output('onThreadSelected')
  threadSelectedEvent: EventEmitter<IChatThread> = new EventEmitter();

  @Input('search')
  search: Observable<string>;

  private $subscription: Subscription = null;

  constructor(
    private threadService: ChatThreadService,
    private messageService: ChatMessageService,
    private chatService: ChatService,
    private detectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const debouncedSearch = this.search.pipe(debounceTime(10));
    this.threads = this.chatService.getThreads().pipe(
      tap(() => {
        this.detectorRef.markForCheck();
      })
    );
    // this.threads = combineLatest([
    //   this.threadService.onThreadsChange,
    //   this.messageService.messages,
    //   debouncedSearch,
    // ]).pipe(
    //   tap(() => {
    //     this.detectorRef.markForCheck();
    //   }),
    //   map(([threads, messages, search]) => {
    //     return threads
    //       .filter((thread) => thread.name.includes(search))
    //       .map<ChatThread>((t) => {
    //         const unSeenMessages = messages.filter(
    //           (msg) => msg.threadId == t.id && !msg.seen && !msg.reply
    //         );

    //         const lastMessage = unSeenMessages.reduce(
    //           (last, m) => (last?.dateTime > m.dateTime ? last : m),
    //           null
    //         );
    //         //console.log("UnSeen Messages", unSeenMessages, lastMessage);
    //         return {
    //           ...t,
    //           unSeenCount: unSeenMessages.length,
    //           lastMessage,
    //         };
    //       })
    //       .sort((t1, t2) => {
    //         return (t2.lastMessage?.id || 0) - (t1.lastMessage?.id || 0);
    //         // if(t2.lastMessage?.dateTime != t1.lastMessage?.dateTime)
    //         //   return t2.lastMessage?.dateTime > t1.lastMessage?.dateTime ? 1 : -1;
    //         // return 0;
    //       });
    //   })
    // );
    interval(30 * 1000).subscribe(() => {
      this.detectorRef.markForCheck();
    });
  }

  onThreadSelected(thread: IChatThread) {
    this.threadSelectedEvent.emit(thread);
  }

  readonly getThreadStatusText = getThreadStatusText;
  readonly isThreadOnline = isThreadOnline;
  // getThreadStatusText(thread: IChatThread) {
  //   const tUser = thread.users[0];

  //   const lastSeen = Number(this.parseISODate(tUser.lastSeen));
  //   var diffStr = moment.duration(Date.now() - lastSeen).humanize();

  //   if (tUser?.active) return `${tUser?.name} is online`;
  //   else if (lastSeen < 0) return `${tUser.name} is offline`;
  //   else return `${tUser.name} last seen ${diffStr} ago`;
  // }
}
